<template>
  <single-panel-page>
    <div v-if="!subscribed">
      <div class="form" :class="{ 'loader-cover': inProgress }">
        <input
          v-model="email"
          class="form-control"
          type="text"
          placeholder="Business e-mail"
          autofocus
          :class="{ 'has-errors': errors.email.length }"
          @keyup.enter="submit()"
        />
        <p
          v-for="error in errors.email"
          :key="error"
          class="text-danger text-sm"
        >
          {{ error }}
        </p>

        <div class="radio-select flex justify-between">
          <div v-for="choice in typeChoices" :key="choice.value">
            <div class="radio">
              <label>
                <input
                  v-model="type"
                  type="radio"
                  name="type"
                  :value="choice.value"
                />
                <span>{{ choice.label }}</span>
              </label>
            </div>
          </div>
        </div>
        <p
          v-for="error in errors.type"
          :key="error"
          class="text-danger text-sm text-radio"
        >
          {{ error }}
        </p>
      </div>

      <div class="checkbox required">
        <span>*</span>
        <label>
          <input v-model="gpdrConsent" type="checkbox" />
          <span>
            I agree my personal data will be stored and processed for the
            purposes of online communication
          </span>
        </label>

        <p
          v-for="error in errors.gpdrConsent"
          :key="error"
          class="text-danger text-sm text-radio"
        >
          {{ error }}
        </p>
      </div>

      <read-more
        class="gdpr-text"
        more-str="read more"
        less-str="read less"
        :text="gdprText"
        :max-chars="190"
      />

      <div class="row">
        <div class="col-sm-12 text-right">
          <button
            class="btn btn-block btn-primary text-uppercase"
            :disabled="inProgress"
            @click="submit"
          >
            <span>Join invite list</span>
          </button>
        </div>
      </div>
    </div>

    <div v-show="subscribed" class="row animated fadeIn">
      <div class="col-sm-12">
        <p class="text-info text-sm">
          Thank you for signing up to our invite list! Our team will contact you
          within 24h to talk about cooperation possibilities.
        </p>
      </div>
    </div>
    <div>
      <a
        class="forgot-password text-muted text-sm"
        href="https://www.vestbee.com"
      >
        Back to home page.
      </a>
    </div>
  </single-panel-page>
</template>

<script>
import Promise from 'bluebird'
import Auth from 'services/Auth'
import GlobalSettings from 'GlobalSettings'

export default {
  data: function () {
    return {
      email: '',
      type: '',
      inProgress: false,
      subscribed: false,
      errors: { email: [], type: [], gpdrConsent: [] },
      gdprText: `Point (a) Art. 6(1) and the content of the General Data Protection Regulation are the basis for the processing of personal data provided. According to Art 13 (1) and (2) of the General Data Protection Regulation of 27 April 2016 we hereby inform that the administrator of your personal data collected via www.vestbee.com will be Vestbee Sp. z o.o, with registered office at ul. Padewska 23/7, 00-077 Warsaw, Poland, mail: office@vestbee.com. The personal data provided will be stored as long as you will remain a user of Vestbee. The provision of data is voluntary, but necessary for use of Vestbee platform.

You have the right to request from the controller access to your personal data, as well as rectification or erasure of data provided or restriction of processing or to object to processing as well as the right to data portability. You also have the right to withdraw consent at any time, without affecting the lawfulness of processing based on consent before its withdrawal.

You have the right to lodge a complaint with a Polish supervisory authority if you suppose that the processing of your personal data violates the law of the General Data Protection Regulation of 27 April 2016.`,
      gpdrConsent: false,
    }
  },
  computed: {
    LANDING_URL: () => GlobalSettings.LANDING_URL,
    hasErrors: function () {
      return this.errors.email.length || this.errors.type.length
    },
    typeChoices: () => [
      {
        label: 'Startup',
        value: 'startup',
      },
      {
        label: 'Investor',
        value: 'investor',
      },
      {
        label: 'Corporate',
        value: 'corporate',
      },
      {
        label: 'Accelerator',
        value: 'accelerator',
      },
    ],
  },
  watch: {
    gpdrConsent(val) {
      if (val) this.errors.gpdrConsent = []
    },
  },
  created() {
    const typeValues = this.typeChoices.map((c) => c.value)
    const typeParam = this.$route.query.t
    const emailParam = this.$route.query.email
    if (emailParam) {
      this.email = emailParam
    }
    if (typeParam && typeValues.includes(typeParam)) {
      this.type = typeParam
      const query = { ...this.$route.query }
      delete query.t
      const newRoute = { ...this.$route, query }
      this.$router.replace(newRoute)
    }
  },
  methods: {
    submit() {
      this.clearErrors()
      if (this.type === '') {
        Object.assign(this.errors, {
          type: ['Please choose your career background.'],
        })
        return
      }
      if (this.type === 'startup') {
        const route = {
          name: 'organizationPageRegisterStartup',
          params: { orgId: 'vestbee' },
          query: { email: this.email },
        }
        this.$router.push(route)
        return
      }
      if (!this.gpdrConsent) {
        Object.assign(this.errors, {
          gpdrConsent: ['Please check GPDR consent checkbox.'],
        })
        return
      }
      this.inProgress = true
      let request = Auth.subscribe(this.email, this.type)
      request = Promise.delay(1000).return(request)
      request
        .then(() => {
          this.inProgress = false
          this.subscribed = true
        })
        .catch((error) => {
          console.log(' => subscribe failed! response:', error.response)
          Object.assign(this.errors, error.response.data)
          this.inProgress = false
        })
    },
    clearErrors() {
      this.errors = { email: [], type: [] }
    },
  },
}
</script>

<style scoped lang="scss">
@import '~assets/css/colors.scss';

.radio-select {
  display: flex;
  justify-content: space-between;

  .flex-end {
    span {
      margin-right: 0;
    }
  }
}

.gdpr-text {
  font-size: 15px;
  font-weight: 200;
  color: $grey90;
  max-width: 500px;
  width: 100%;
  margin: 0 auto 20px;
  text-align: justify;
}

.text-radio {
  margin-top: 0;
}

.required {
  > span {
    position: absolute;
    left: -12px;
    top: 1px;
    font-size: 14px;
    color: $danger;
  }
}
</style>
